<div class="card">
  <div class="card-top"></div>

  <div class="ornament">
    <span class="ornament-line"></span>
    <span class="ornament-diamond"></span>
    <span>restricted area</span>
    <span class="ornament-diamond"></span>
    <span class="ornament-line r"></span>
  </div>

  <div class="card-body">
    <div class="lock-wrap">
      <div class="lock-icon">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
          />
        </svg>
      </div>
      <div class="lock-meta">
        <div class="status-chip">
          <span class="chip-dot"></span>
          403 — Forbidden
        </div>
        <span class="error-num">Authorization Required</span>
      </div>
    </div>

    <h1>ACCESS <span>RESTRICTED</span></h1>

    <p class="message">
      You don't have the necessary permissions to view this section. This area
      is restricted to authorized personnel only.
    </p>

    <div class="info-box">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
        />
      </svg>
      <span
        >Think this is a mistake? Contact your
        <strong>system administrator</strong> to request access.</span
      >
    </div>

    <div class="actions">
      <button routerLink="/prodotti" class="btn primary" *ngIf="!groups.includes('partner')">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20 4H4v2l16-.01V4zm1 5v-2H3v2l9 5 9-5zm-9 7L3 11v9h18v-9l-9 5z"
          />
        </svg>
        Go to Products
      </button>
      <button routerLink="/profilo" class="btn secondary">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"
          />
        </svg>
        My Profile
      </button>
    </div>
  </div>

  <div class="card-footer">
    <span class="footer-left">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"
        />
      </svg>
      Secured Access Control
    </span>
    <span class="err-code">ERR_AUTH_INSUFFICIENT</span>
  </div>
</div>
